(ns lupapalvelu.ui2.input
  (:require [lupapalvelu.ui2.util :refer [defuic]]
            [lupapalvelu.ui2.variant-builder :refer [builder merge-props-classes]]))

(def variants
  {:base     {:root ["bg-input-fill-enabled"
                     "border-1" "border-input-stroke-default"
                     "w-full"
                     "focus-visible:outline-2 focus-visible:outline-input-stroke-focus"]}
   :defaults {:size :md}
   :variants {:intent   {}
              :size     {:md {:root ["px-3" "py-2" "rounded-md"]}
                         :lg {:root ["px-4" "py-3" "rounded-lg"]}}
              :type     {"text"     {}
                         "radio"    {}
                         "checkbox" {}
                         "select"   {}
                         "textarea" {}}
              :disabled {true  {:root ["pointer-events-none" "bg-state-disabled-fill-tertiary"
                                       ;; "text-text-disabled" ;; ui-neutral-light not enough contrast?
                                       "text-ui-neutral-mid"
                                       "border-state-disabled-stroke-secondary"]}
                         false {}}}})

(def classes
  (builder variants))

(defuic input
  [props _children]
  [:input
   (merge-props-classes (dissoc props :size)
                        (classes props :root))])

(defuic select
  [props children]
  (into [:select
         (merge-props-classes (-> (dissoc props :size)
                                  (assoc :type "select"))
                              (-> props
                                  (assoc :disabled (boolean (:disabled props)))
                                  (classes :root)))]
        children))

(defuic textarea [props _children]
  [:textarea
   (merge-props-classes (-> (dissoc props :size)
                            (assoc :type "textarea"))
                        (-> props
                            (assoc :disabled (boolean (:disabled props)))
                            (classes :root)))])
